module.exports = __webpack_public_path__ + "img/horizontal_bar_base.d1d29d3f.svg";